import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const ICON_TONES = {
  blue:    "bg-blue-50    text-blue-600    ring-blue-100",
  indigo:  "bg-indigo-50  text-indigo-600  ring-indigo-100",
  violet:  "bg-violet-50  text-violet-600  ring-violet-100",
  cyan:    "bg-cyan-50    text-cyan-600    ring-cyan-100",
  emerald: "bg-emerald-50 text-emerald-600 ring-emerald-100",
  amber:   "bg-amber-50   text-amber-600   ring-amber-100",
  rose:    "bg-rose-50    text-rose-600    ring-rose-100",
  slate:   "bg-slate-100  text-slate-600   ring-slate-200",
}

export const formatMoney = (cents, symbol) => {
  if (cents == null || isNaN(cents)) return "—"
  return `${(cents / 100).toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })} ${symbol || "€"}`
}

const Tile = ({ icon, iconTone = "blue", label, value, sub }) => (
  <div className="bg-white border border-slate-200 rounded-xl px-4 py-3.5 shadow-sm shadow-slate-900/[0.03]">
    <div className="flex items-start justify-between">
      <div className="text-[10.5px] uppercase tracking-wider font-semibold text-slate-500">
        {label}
      </div>
      <div className={`shrink-0 w-7 h-7 grid place-items-center rounded-lg ring-1 ${ICON_TONES[iconTone] || ICON_TONES.blue}`}>
        <FontAwesomeIcon icon={icon} className="w-3 h-3" />
      </div>
    </div>
    <div className="mt-2 text-[26px] leading-none font-bold tabular-nums text-slate-900">
      {value}
    </div>
    {sub && (
      <div className="mt-1.5 text-[11.5px] text-slate-500 truncate">{sub}</div>
    )}
  </div>
)

const StatsStrip = ({ stats }) => {
  if (!stats) return null
  const sym = stats.currency_symbol || "€"

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3 mb-5">
      <Tile
        icon     = "calculator"
        iconTone = "indigo"
        label    = {I18n.t("projects.index.stats.total_budget")}
        value    = {formatMoney(stats.total_budget_cents, sym)}
        sub      = {I18n.t("projects.index.count", { count: stats.count })}
      />
      <Tile
        icon     = "circle-play"
        iconTone = "emerald"
        label    = {I18n.t("projects.index.stats.active")}
        value    = {String(stats.active_count ?? 0)}
        sub      = {formatMoney(stats.active_budget_cents, sym)}
      />
      <Tile
        icon     = "circle-pause"
        iconTone = "amber"
        label    = {I18n.t("projects.index.stats.on_hold")}
        value    = {String(stats.on_hold_count ?? 0)}
      />
      <Tile
        icon     = "clipboard-check"
        iconTone = "violet"
        label    = {I18n.t("projects.statuses.reception", { defaultValue: "Réception" })}
        value    = {String(stats.reception_count ?? 0)}
      />
      <Tile
        icon     = "circle-check"
        iconTone = "cyan"
        label    = {I18n.t("projects.index.stats.completed")}
        value    = {String(stats.completed_count ?? 0)}
        sub      = {formatMoney(stats.completed_budget_cents, sym)}
      />
      <Tile
        icon     = "pencil-ruler"
        iconTone = "slate"
        label    = {I18n.t("projects.statuses.draft", { defaultValue: "Préparation" })}
        value    = {String(stats.draft_count ?? 0)}
      />
    </div>
  )
}

export default StatsStrip
